import type * as React from 'react';
import { styled } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import type { NamedColors } from '@/muiTheme';

export type ParagraphProps = {
    color?: NamedColors;
    small?: boolean;
    className?: string;
    children: React.ReactNode;
    sx?: SxProps<Theme>;
};
export const Paragraph = styled('p', {
    shouldForwardProp: (prop) =>
        !['sx', 'color', 'small'].includes(prop as string),
})<ParagraphProps>(({ theme, small, color }) => ({
    ...(small
        ? {
              fontSize: '14px',
              lineHeight: '22px',
          }
        : {
              fontSize: '16px',
              lineHeight: '24px',
          }),
    fontWeight: 'normal',
    margin: '0 0 8px 0',
    color: theme.bino.color[color] ?? undefined,
    [theme.breakpoints.up('sm')]: {
        ...(small
            ? {}
            : {
                  fontSize: '18px',
                  lineHeight: '28px',
                  margin: '0 0 12px 0',
              }),
    },
}));
